/**
 * Lightweight semver comparison utility for client-side version comparison.
 *
 * Used by TosGate to compare acceptedTosVersion against activeTosVersion.
 *
 * Requirements: 5.1, 10.1
 */

/**
 * Compare two semver MAJOR.MINOR.PATCH strings.
 * Returns -1 if a < b, 0 if equal, 1 if a > b.
 * Handles malformed input gracefully by returning 0 to avoid blocking users.
 */
export function compareSemver(a: string, b: string): -1 | 0 | 1 {
  const pattern = /^\d+\.\d+\.\d+$/;
  if (!pattern.test(a) || !pattern.test(b)) return 0;

  const aParts = a.split('.').map(Number);
  const bParts = b.split('.').map(Number);

  for (let i = 0; i < 3; i++) {
    if (aParts[i]! < bParts[i]!) return -1;
    if (aParts[i]! > bParts[i]!) return 1;
  }
  return 0;
}
